module.exports = __webpack_public_path__ + "img/tips-clock-icon.b8962e25.svg";